/* ==========================================================================
   IRON CREST LEATHER — product-page.js
   Owns only what the product template adds: the gallery, the option and bundle
   selectors, the quantity stepper, the review paging and the sticky bar.

   Cart behaviour still belongs to product-card.js — the buy buttons here carry
   the same [data-add] contract, so quick add, the drawer and the counts all
   work without this file knowing anything about them.

   Shopify: assets/product-page.js, loaded with `defer` from the product
   template. Every hook is a data attribute, so the markup can move into
   sections/main-product.liquid untouched.
   ========================================================================== */
(function () {
  function boot() {
    'use strict';

    var page = document.querySelector('[data-section-type="main-product"]');
    if (!page) return;
    if (page.icBooted) return;   // already live; the editor replaced a different section
    page.icBooted = true;

    /* ---------------------------------------------------------------- gallery */
    var frames = page.querySelectorAll('.pdp__frame');
    var thumbs = page.querySelectorAll('[data-thumbs] .pdp__thumb');

    function show(index) {
      Array.prototype.forEach.call(frames, function (f, i) {
        f.classList.toggle('is-active', i === index);
      });
      Array.prototype.forEach.call(thumbs, function (t, i) {
        var on = i === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () { show(+t.getAttribute('data-go')); });
    });

    // arrow keys move through the gallery while a thumbnail has focus
    var thumbList = page.querySelector('[data-thumbs]');
    if (thumbList) {
      thumbList.addEventListener('keydown', function (e) {
        var i = Array.prototype.indexOf.call(thumbs, document.activeElement);
        if (i === -1) return;
        var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
        if (n === null) return;
        e.preventDefault();
        n = (n + thumbs.length) % thumbs.length;
        thumbs[n].focus();
        show(n);
      });
    }

    /* ------------------------------------------------- options: colour + size */
    var buyBtns = document.querySelectorAll('[data-add][data-id="41002"]');
    var stickyVariant = document.querySelector('[data-sticky-variant]');
    var colourName = page.querySelector('[data-colour-name]');
    var chosen = { colour: 'Chestnut', size: 'M' };

    function syncVariant() {
      var label = chosen.colour + ' · ' + chosen.size;
      Array.prototype.forEach.call(buyBtns, function (b) {
        b.setAttribute('data-variant', label);
      });
      if (stickyVariant) stickyVariant.textContent = label;
      if (colourName) colourName.textContent = chosen.colour;
    }

    // product-card.js already owns the swatch pressed state; this only reads the
    // result back into the variant label
    page.addEventListener('click', function (e) {
      var sw = e.target.closest('.swatch');
      if (sw) {
        chosen.colour = sw.getAttribute('aria-label') || chosen.colour;
        syncVariant();
        return;
      }

      var size = e.target.closest('.pdp__size');
      if (size && !size.disabled) {
        Array.prototype.forEach.call(page.querySelectorAll('.pdp__size'), function (s) {
          s.classList.remove('is-selected');
          s.setAttribute('aria-pressed', 'false');
        });
        size.classList.add('is-selected');
        size.setAttribute('aria-pressed', 'true');
        chosen.size = size.textContent.trim();
        syncVariant();
        return;
      }

      var step = e.target.closest('[data-pdp-qty]');
      if (step && qtyValue) {
        var next = parseInt(qtyValue.textContent, 10) + parseInt(step.getAttribute('data-pdp-qty'), 10);
        next = Math.max(1, Math.min(9, next));
        qtyValue.textContent = next;
        // product-card.js owns the cart; it reads the count off the button
        Array.prototype.forEach.call(buyBtns, function (btn) {
          btn.setAttribute('data-qty', String(next));
        });
        // the form posts `quantity`, so the stepper has to move that too or a
        // no-JS submit would always add one
        var qtyInput = page.querySelector('[data-qty-input]');
        if (qtyInput) qtyInput.value = String(next);
      }
    });

    /* ------------------------------------------------------ bundle and price */
    var tiers = page.querySelectorAll('[data-bundle] .pdp__tier');
    var priceNow = page.querySelector('[data-price-now]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var qtyValue = page.querySelector('[data-pdp-qty-value]');

    function money(n) { return '$' + n.toLocaleString('en-US'); }

    Array.prototype.forEach.call(tiers, function (tier) {
      var input = tier.querySelector('[data-tier]');
      if (!input) return;
      input.addEventListener('change', function () {
        Array.prototype.forEach.call(tiers, function (t) { t.classList.remove('is-selected'); });
        tier.classList.add('is-selected');

        var value = parseInt(input.value, 10);
        if (priceNow) priceNow.textContent = money(value);
        if (stickyPrice) stickyPrice.textContent = money(value);
        Array.prototype.forEach.call(buyBtns, function (b) {
          b.setAttribute('data-price', String(value));
        });
      });
    });

    /* --------------------------------------------------------- review paging */
    var revMore = document.querySelector('[data-reviews-more]');
    var hiddenRevs = document.querySelectorAll('[data-reviews] [data-more]');
    if (revMore && hiddenRevs.length) {
      revMore.hidden = false;
      revMore.addEventListener('click', function () {
        Array.prototype.forEach.call(hiddenRevs, function (r) { r.hidden = false; });
        revMore.setAttribute('aria-expanded', 'true');
        revMore.hidden = true;
        var first = hiddenRevs[0].querySelector('p');
        if (first) { first.setAttribute('tabindex', '-1'); first.focus(); }
      });
    }

    /* ------------------------------------------------------------ sticky bar */
    /* Appears once the real Add to bag has scrolled away, so the two are never
       on screen together competing for the same click.

       Driven by scroll rather than IntersectionObserver: the button sits inside
       a position:sticky column, and the observer only ever delivered its first
       entry here — it never fired again as the column unpinned. A rAF-throttled
       scroll read is deterministic and costs one rect per frame. */
    var bar = document.querySelector('[data-stickybar]');
    var anchor = page.querySelector('.pdp__buy');

    if (bar && anchor) {
      bar.hidden = false;
      var ticking = false;

      var place = function () {
        ticking = false;
        var gone = anchor.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('is-up', gone);
        bar.setAttribute('aria-hidden', gone ? 'false' : 'true');
      };

      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(place);
      }, { passive: true });
      window.addEventListener('resize', place);
      place();
    }

    syncVariant();
  }

  boot();

  /* The editor replaces a section's markup wholesale on every change, so the
     script has to run again over the new nodes. Storefront visitors never get
     here -- they booted once above. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { boot(); });
  }
})();
